<template>
  <div>
    <div class="px-4 pt-4 pb-6">
      <div
        class="border-secondary pt-3 px-4 ltr:pr-1 rtl:pl-1 border overflow-hidden rounded-sm flex flex-col gap-1.5"
        :class="{
          'pb-3': isEmpty(properties.slice(max, properties.length)),
        }"
      >
        <Properties
          :key="selectedBuilding?.id"
          :buildingId="selectedBuilding?.id"
          :properties="properties"
          :max="max"
          @update:form="emit('update:form', $event)"
          @goToStep="emit('goToStep', $event)"
        />
        <div
          v-if="!isEmpty(properties.slice(max, properties.length))"
          class="-mx-1.5 pb-[7px]"
        >
          <Button
            :label="
              t('components.asset_create.more_properties', {
                value: properties.slice(max, properties.length).length,
              })
            "
            variant="tertiary"
            type="gray"
            size="2xs"
            class="h-6"
            @click="max = properties.length"
          >
            <template #start>
              <Icon name="chevron-right" />
            </template>
          </Button>
        </div>
      </div>
    </div>
    <div
      class="bg-secondary h-full px-6 py-4 border-t border-secondary flex flex-col gap-4"
    >
      <PassportNav>
        <PassportNavItem
          @navigate="
            maxSmall
              ? (isSpaceModalOpen = true)
              : emit('goToStep', PropertyType.SPACE)
          "
          variant="space"
          :placeholder="t('components.asset_create.space.placeholder')"
          :label="form.space?.name"
        />
        <PassportNavItem
          @navigate="
            maxSmall
              ? (isAssetGroupModalOpen = true)
              : emit('goToStep', PropertyType.ASSET_GROUP)
          "
          variant="asset_group"
          :placeholder="t('components.asset_create.asset_group.placeholder')"
          :label="form.group?.name"
        />
      </PassportNav>
      <SpaceSelectModal
        :title="$t('components.asset_create.steps.space_select_title')"
        :withSearch="true"
        :open="isSpaceModalOpen"
        :initialState="form.space?.id"
        :buildingId="selectedBuilding?.id"
        @update:open="isSpaceModalOpen = $event"
        @update="
          emit('update:form', { property: PropertyType.SPACE, value: $event })
        "
      >
        <template #header>test</template>
      </SpaceSelectModal>

      <AssetGroupSelectModal
        :title="$t('components.asset_create.steps.group_select_title')"
        :withSearch="true"
        :open="isAssetGroupModalOpen"
        :initialState="form.space?.id"
        :buildingId="selectedBuilding?.id"
        @update:open="isAssetGroupModalOpen = $event"
        @update="
          emit('update:form', {
            property: PropertyType.ASSET_GROUP,
            value: $event,
          })
        "
      >
        <template #header>test</template>
      </AssetGroupSelectModal>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watchEffect } from "vue";
import { isEmpty } from "lodash";
import { useI18n } from "vue-i18n";
import { Button } from "@/SharedComponents/Buttons";
import { Icon } from "@/SharedComponents/Icon";
import { Properties } from "@/Pages/Assets/Partials/Create";
import { PassportNav, PassportNavItem } from "@/SharedComponents/Passport";
import { useSites } from "@/Composables/useSites";
import { useProperties, PropertyType } from "@/Composables/useProperties";
import {
  SpaceSelectModal,
  AssetGroupSelectModal,
} from "@/SharedComponents/Modals";
import { useBreakpoints } from "@/Composables/useBreakpoints";

// Translations
const { t } = useI18n();
const max = ref(5);

// Sites
const { isLoading, data: sites } = useSites();

// Breakpoints
const { maxSmall } = useBreakpoints();

// Emits
const emit = defineEmits(["update:form", "update:building", "goToStep"]);

// Define Props
const props = defineProps({
  form: { type: Object, required: true },
  buildingId: { type: String, required: false },
});

// Refs
const selectedBuilding = ref({});
const isSpaceModalOpen = ref(false);
const isAssetGroupModalOpen = ref(false);
const { properties } = useProperties("assets", props.form);

const buildings = computed(() => {
  if (isLoading.value) {
    return [];
  }

  return sites.value;
});

watchEffect(() => {
  selectedBuilding.value =
    buildings.value.find((el) => el.id === props.buildingId) || {};
});
</script>
